// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateWidgetHostConfigRequestModel from '../../model/update-widget-host-config-request-model';
import UpdateWidgetHostConfigRequestDTO from '../dto/update-widget-host-config-request-dto';
import dtoSchema from '../schemas/update-widget-host-config-request-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class UpdateWidgetHostConfigRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateWidgetHostConfigRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.name = data.name ?? undefined;
      this.hostKey = data.hostKey ?? undefined;
      this.loaderUrl = data.loaderUrl ?? undefined;
      this.allowedReferers = data.allowedReferers ?? undefined;
      this.languageIso2 = data.languageIso2 ?? undefined;
      this.locale = data.locale ?? undefined;
      this.entryPoint = data.entryPoint ?? undefined;
      this.navigation = data.navigation ?? undefined;
      this.startParameters = data.startParameters ?? undefined;
      this.apiKey = data.apiKey ?? undefined;
      this.isDebug = data.isDebug;
      this.isActive = data.isActive;
      this.textContentScope = data.textContentScope ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @minimum 3
  * @maximum 100
  */
  name?: string;
  /**
  * @minimum 1
  * @maximum 100
  */
  hostKey?: string;
  /**
  * @maximum 255
  */
  loaderUrl?: string;
  /**
  * @maximum 500
  */
  allowedReferers?: string;
  /**
  * @maximum 2
  */
  languageIso2?: string;
  /**
  * @minimum 2
  * @maximum 5
  */
  locale?: string;
  /**
  * @maximum 100
  */
  entryPoint?: string;
  /**
  * @maximum 50
  */
  navigation?: string;
  /**
  */
  startParameters?: string;
  /**
  * @maximum 255
  */
  apiKey?: string;
  /**
  */
  isDebug?: boolean;
  /**
  */
  isActive?: boolean;
  /**
  * @maximum 150
  */
  textContentScope?: string;

  static toModel(dto: DeepPartial<UpdateWidgetHostConfigRequestDTO>): UpdateWidgetHostConfigRequestModel;
  static toModel(dto: DeepPartial<UpdateWidgetHostConfigRequestDTO> | undefined | null): UpdateWidgetHostConfigRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateWidgetHostConfigRequestDTO> | undefined | null): UpdateWidgetHostConfigRequestModel | undefined {
    return dto ? new UpdateWidgetHostConfigRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateWidgetHostConfigRequestModel> | UpdateWidgetHostConfigRequestModel): UpdateWidgetHostConfigRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      name: unwrapped.name,
      hostKey: unwrapped.hostKey,
      loaderUrl: unwrapped.loaderUrl,
      allowedReferers: unwrapped.allowedReferers,
      languageIso2: unwrapped.languageIso2,
      locale: unwrapped.locale,
      entryPoint: unwrapped.entryPoint,
      navigation: unwrapped.navigation,
      startParameters: unwrapped.startParameters,
      apiKey: unwrapped.apiKey,
      isDebug: unwrapped.isDebug,
      isActive: unwrapped.isActive,
      textContentScope: unwrapped.textContentScope,
    } as UpdateWidgetHostConfigRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateWidgetHostConfigRequestModel, can not map to UpdateWidgetHostConfigRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
